"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "modal-container" };
var _hoisted_2 = { class: "modal-title-section" };
var _hoisted_3 = { class: "title-msg" };
var _hoisted_4 = { class: "modal-box-container" };
var _hoisted_5 = {
    key: 0,
    class: "message-text"
};
var _hoisted_6 = {
    key: 1,
    class: "success-msg-text"
};
var _hoisted_7 = {
    key: 2,
    class: "error-msg-text"
};
var _hoisted_8 = { class: "reason-text-section" };
var _hoisted_9 = { class: "container button-action" };
var _hoisted_10 = ["disabled"];
var vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'DiscontinueModal',
    props: {
        disapproveReason: {},
        parentMsg: {},
        titleBar: {},
        ordtaxonomy: {},
        naModal: {}
    },
    emits: ['submitDiscontinue', 'cancelDiscontinue', 'closeDCModal'],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var count = (0, vue_3.ref)(0);
        var notapproveReason = (0, vue_3.ref)('');
        var dialogTitle = (0, vue_3.ref)('Tiltle Bar');
        var discText = (0, vue_3.ref)('');
        var didConfirm = (0, vue_3.ref)(false);
        var successMsg = (0, vue_3.ref)('');
        var errorMsg = (0, vue_3.ref)('');
        var notelength = (0, vue_3.computed)(function () { return (discText.value || '').trim().length; });
        function closeDCPanel() {
            emit('closeDCModal');
        }
        function showNAModal() {
            //Need to update function so that It has data to return a `real` boolean and not just fixed
            if (props.naModal == "true") {
                return true;
            }
            else {
                return false;
            }
        }
        function metRequirements() {
            return showErrorMsg();
        }
        function confirmiationAction() {
            // alert("Confirm here later");
            if (notelength.value >= 10) {
                successMsg.value = "Now Submitting Your DC Order....";
                didConfirm.value = true;
                //then we are going to submit and pass the text and other parameters
                emit('submitDiscontinue', discText.value);
            }
        }
        function cancelAction() {
            //alert("Cancel Action Here");
            didConfirm.value = false; //clear
            showSuccessMsg();
            console.log(showSuccessMsg());
            emit('cancelDiscontinue');
        }
        function showErrorMsg() {
            if (notelength.value > 2 && notelength.value < 10) {
                errorMsg.value = "*Order Description needs to be more than 10 characters.";
                return true;
            }
            else {
                errorMsg.value = "";
                return false;
            }
        }
        function showSuccessMsg() {
            if (didConfirm.value == true) {
                return true;
            }
            else {
                return false;
            }
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("span", null, null, -1)),
                    (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)(_ctx.titleBar), 1),
                    (0, vue_2.createElementVNode)("span", {
                        class: "close-modal",
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (closeDCPanel()); })
                    }, "X")
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (!showSuccessMsg())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_5, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.parentMsg) + " ", 1),
                            (0, vue_2.createElementVNode)("b", null, (0, vue_2.toDisplayString)(_ctx.ordtaxonomy), 1),
                            _cache[3] || (_cache[3] = (0, vue_2.createTextVNode)(" Order?", -1))
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showSuccessMsg())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_6, (0, vue_2.toDisplayString)(successMsg.value), 1))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showErrorMsg() && !showSuccessMsg())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_7, [
                            (0, vue_2.createElementVNode)("b", null, (0, vue_2.toDisplayString)(errorMsg.value), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((discText).value = $event); }),
                            class: "text-box",
                            placeholder: "Reason Order is not approved..."
                        }, " \n \n                ", 512), [
                            [vue_2.vModelText, discText.value]
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "ok-btn",
                            onClick: confirmiationAction,
                            disabled: metRequirements()
                        }, "Confirm", 8, _hoisted_10),
                        (0, vue_2.createElementVNode)("button", {
                            class: "cancel-btn",
                            onClick: cancelAction
                        }, "Cancel")
                    ])
                ])
            ]));
        };
    }
});
